module.exports = __webpack_public_path__ + "media/images/flags/pr-236ee866e6008f711adc2b0c53e8f6f5.svg";